import { useContext, useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  KEY_DOWN_COMMAND,
  COMMAND_PRIORITY_LOW,
  $getSelection,
  $isRangeSelection,
} from "lexical";
import {
  FindReplaceContext,
  OPEN_FIND_REPLACE_COMMAND,
} from "./FindReplacePlugin";

export function FindReplaceKeyboardPlugin(): null {
  const [editor] = useLexicalComposerContext();
  const ctx = useContext(FindReplaceContext);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const { ctrlKey, metaKey, key } = event;

      // Check for Ctrl+F (Windows/Linux) or Cmd+F (Mac)
      if ((ctrlKey || metaKey) && key.toLowerCase() === "f") {
        event.preventDefault();
        const selection = $getSelection();

        if ($isRangeSelection(selection) && ctx?.setSearchTerm) {
          ctx?.setSearchTerm(selection.getTextContent());
        }
        editor.dispatchCommand(OPEN_FIND_REPLACE_COMMAND, undefined);
        return true;
      }

      return false;
    };

    return editor.registerCommand(
      KEY_DOWN_COMMAND,
      handleKeyDown,
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
}
